import 'ui-theme/components/modal/js/modal';

const {modal} = UX || {};
var $body = $('body');

if (modal) {
    modal.on.hide = () => {
        $body.removeAttr('data-active');
        modal.accessibility.hide();
        modal.$target.closest("[class*='sticko']").removeClass('js--open');
        $body.find('.modal-backdrop').remove();
    };
}
